import PauseIcon from '@mui/icons-material/Pause'
import type { LicensePropertyOperatorData } from '@/stores/licenseProperty'

import { CheckboxMenuSelectedItem } from '../CheckboxMenuSelectedItem/CheckboxMenuSelectedItem'

interface CheckboxSuspendLicenseForOperatorsItemProps {
  onSuspend: (rows: LicensePropertyOperatorData[]) => Promise<void> | void
  licenseProperty: string
}

export function CheckboxSuspendLicenseForOperatorsItem({
  onSuspend,
  licenseProperty
}: CheckboxSuspendLicenseForOperatorsItemProps) {
  return (
    <CheckboxMenuSelectedItem
      onAction={onSuspend}
      renderItem={(row) => `${row.name} (${row.id})`}
      successMessage={(rows) =>
        `License ${licenseProperty} suspended for ${rows.length} operator(s) successfully`
      }
      errorMessage={(rows) =>
        `Failed to suspend license ${licenseProperty} for ${rows.length} operator(s)`
      }
      confirmationTitle="Suspend License"
      confirmationMessage={`Are you sure you want to suspend license ${licenseProperty} for the following operators? Already suspended licenses will not be affected.`}
      actionLabel="Suspend"
      icon={<PauseIcon />}
    />
  )
}
